export default __webpack_public_path__ + "static/lut-virusi-lutein-complex-86e6af975617f93709e194eb6f0df3d6.jpg";